import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { resolvePhone, resolveSessionCookie } from "../webOrderApi";

// Extracted verbatim from WebOrderPage.jsx so /order and /menu resolve the
// customer's identity identically — same sessionId, same tracking
// attribution, same fallback-to-anonymous behavior — without duplicating
// this logic in two places. See WebOrderPage.jsx's own top-of-file comment
// for the two-flow explanation (?cp= URL phone vs. the returning-customer
// cookie) this mirrors exactly.
export default function useIdentity() {
  const [searchParams] = useSearchParams();
  const phoneFromUrl = searchParams.get("cp");

  const [sessionId, setSessionId] = useState(null);
  const [resolvingIdentity, setResolvingIdentity] = useState(true);

  useEffect(() => {
    if (!phoneFromUrl) return;
    resolvePhone(phoneFromUrl)
      .then((res) => {
        if (res.success) setSessionId(res.sessionId);
      })
      .catch(() => {})
      .finally(() => setResolvingIdentity(false));
  }, [phoneFromUrl]);

  useEffect(() => {
    if (phoneFromUrl) return;
    resolveSessionCookie()
      .then((res) => {
        if (res.success) setSessionId(res.sessionId);
      })
      .finally(() => setResolvingIdentity(false));
  }, [phoneFromUrl]);

  return { sessionId, resolvingIdentity, phoneFromUrl };
}
